export const fieldTypes = [
    {
      name: 'select an item',
      fa_name: 'لطفا انتخاب کنید',
      value: null,
    },
    {
        name: 'string',
        fa_name: 'فیلد متن کوتاه',
        value: 0,
    },
    {
        name: 'numeric',
        fa_name: 'فیلد عددی',
        value: 1,
    },
    {
        name: 'text',
        fa_name: 'فیلد متن طولانی',
        value: 2,
    },
    {
        name: 'date',
        fa_name: 'فیلد تاریخ',
        value: 3,
    },
    {
        name: 'select',
        fa_name: 'فیلد انتخابی',
        value: 4,
    },
]

export const fieldTypesConstants = {
    STRING: 0,
    NUMERIC: 1,
    TEXT: 2,
    DATE: 3,
    SELECT: 4,
}